module.exports = function() {
  return new Worker(__webpack_public_path__ + "e9151ee46ee57137a317.worker.js");
};